module.exports = __webpack_public_path__ + "static/media/overviewBgc.f3e9cc3c.svg";